// API Configuration
export const API_BASE_URL = "https://api.getmaidly.com/api/v1";

// API Endpoints
export const API_ENDPOINTS = {
    POLICIES: `${API_BASE_URL}/cms/public/policies`,
};
